(function () {
    function orderChannelFilter () {
        return function (input) {

            // If the input is undefined or null, we return undefined|null so that bind once continues to bind until the value is not null.
            if (!input) {
                return input;
            }

            var apps = [ "Android", "iOS" ];
            var isApp = _.some(apps, function (app) {
                return app.toLowerCase() === input.toLowerCase();
            });
            if ("callcenter" === input.toLowerCase()) {
                return "Call Center";
            }
            return isApp ? "App" : input
        };
    }

    angular
        .module('dashboard')
        .filter('orderChannel', [ orderChannelFilter ]);
})();
